import Request from "../request";
const request = new Request();

export class MemberService {
  static list = async (
    category1: string,
    category2: string,
    category3: string,
    category4: string,
    startDate: string,
    endDate: string,
    search: string,
    limit: number,
    offset: number
  ) => {
    const res = await request.get(
      "admin/member/list?" +
        `category1=${category1}&category2=${category2}&category3=${category3}&category4=${category4}&startDate=${startDate}&endDate=${endDate}&search=${search}&limit=${limit}&offset=${offset}`
    );
    return res.data;
  };

  static create = async (data: any) => {
    await request.post("admin/member/create", data);
  };

  static update = async (data: any, userKey: any) => {
    await request.patch("admin/member/update/" + userKey, data);
  };

  static view = async (userKey: any) => {
    const res = await request.get("admin/member/view/" + userKey);
    return res.data;
  };
  static brokerList = async (limit: number, offset: number, search: string) => {
    const res = await request.get(
      `admin/member/broker/list?limit=${limit}&offset=${offset}&search=${search}`
    );
    return res.data;
  };
  static brokerDetail = async (broker_idx: number) => {
    const res = await request.get(`admin/member/broker/${broker_idx}`);
    return res.data;
  };
  static createBroker = async (data: any) => {
    const res = await request.post(`admin/member/broker/create`, data);
    return res.data;
  };
  static updateBroker = async (data: any) => {
    const res = await request.post(`admin/member/broker/update`, data);
    return res.status;
  };
  static regionCode = async (code: string) => {
    const res = await request.get(`admin/region/list?code=${code}`);
    return res.data;
  };
  static deleteBroker = async (broker_idx: string) => {
    const res = await request.patch(`admin/member/broker/${broker_idx}`, {});
    return res.data;
  };

  static async list2(
    loginType: string,
    search: string,
    sort: string,
    startDate: string,
    endDate: string,
    limit: number,
    offset: number
  ) {
    let params = "";

    if (loginType) {
      params += `loginType=${loginType}&`;
    }
    if (sort) {
      params += `sort=${sort}&`;
    }
    if (search) {
      params += `search=${search}&`;
    }
    if (startDate) {
      params += `startDate=${startDate}&`;
    }
    if (endDate) {
      params += `endDate=${endDate}&`;
    }
    if (limit) {
      params += `limit=${limit}&`;
    }
    if (offset) {
      params += `offset=${offset}&`;
    }

    const { data } = await request.get("/users/list2" + (params ? "?" + params.slice(0, -1) : ""));

    return data.data;
  }

  static async recommendCodeList() {
    const endPoint = "/admin/users/recommend-code";
    const { data } = await request.get(endPoint);

    return data.data;
  }
}
